import { render, staticRenderFns } from "./AppointmentNotes.vue?vue&type=template&id=7fd2dea1&"
import script from "./AppointmentNotes.vue?vue&type=script&lang=js&"
export * from "./AppointmentNotes.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentNotes.vue?vue&type=style&index=0&id=7fd2dea1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports